import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import PassResetForm from '../components/app-form/PassResetForm'
import { withSnackbar } from 'notistack'
import { ButtonContained } from '../components/app-button/button'

const styles = theme => ({
  resetPass: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  resetPassTitle: {
    fontSize: 36,
    color: '#979197',
    lineHeight: '48px',
    fontWeight: 300,
    margin: 0,
    textAlign: 'center',
  },
  resetPassSubTitle: {
    lineHeight: '24px',
    fontSize: 16,
    color: '#979197',
    textAlign: 'center',
    fontWeight: 300,
    margin: 0,
    whiteSpace: 'pre',
  },
  resetPassHeading: {
    margin: '0 0 48px 0',
  },
})

class PassReset extends Component {
  state = {
    isFetching: false,
    incomming: false,
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/password/reset'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const handleServerError = message => {
      console.log(message)
      this.setState({
        isFetching: false,
      })

      if (message.errors && message.status == 422) {
        this.setState({
          errors: message.errors,
        })
      } else {
        const error = `Произошла ошибка на сервере (${message.status}). 
        Попробуйте снова или обратитесь в поддержку.`

        this.props.enqueueSnackbar(error, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: 6000,
        })

        if (message.message) {
          this.props.enqueueSnackbar(message.message, {
            variant: 'error',
            preventDuplicate: true,
            autoHideDuration: 6000,
          })
        }
      }
    }

    function handleResponse(response) {
      return response.json().then(json => {
        if (response.ok) {
          return json
        } else {
          let error = Object.assign({}, json, {
            status: response.status,
            statusText: response.statusText,
          })

          return Promise.reject(error)
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ status }) => {
        if (status === 'ok') {
          this.setState({
            incomming: true,
          })
        }
      })
      .catch(message => handleServerError(message))
  }

  render() {
    const { classes } = this.props

    const incomming = (
      <header className={classes.resetPassHeading}>
        <h1 className={classes.resetPassTitle}>Пароль обновлен.</h1>
        <h2 className={classes.resetPassSubTitle}>
          <span style={{ display: 'block' }}>
            Мы успешно изменили ваш пароль.
          </span>
          <a href={'/dashboard'} style={{ marginTop: 24, display: 'block' }}>
            <ButtonContained
              style={{
                height: 48,
                fontSize: 16,
                width: '100%',
                padding: 0,
                fontWeight: 700,
                color: '#fff',
              }}
              type="submit"
              color="secondary"
              text={`Перейти в приложение`}
            />
          </a>
        </h2>
      </header>
    )

    const formReset = (
      <Fragment>
        <header className={classes.resetPassHeading}>
          <h1 className={classes.resetPassTitle}>Восстановление пароля</h1>
        </header>
        <PassResetForm
          onSubmit={this.handleSubmit}
          isFetching={this.state.isFetching}
        />
      </Fragment>
    )

    return (
      <div className={classes.resetPass}>
        {this.state.incomming ? incomming : formReset}
      </div>
    )
  }
}

export default withStyles(styles)(withSnackbar(PassReset))
